export const IMAGE_UPLOAD_LABELS = {
  CHANGE_PROFILE: 'Zmień zdjęcie profilowe', // Change Profile
  DELETE: 'Usuń', // Delete
  CANCEL: 'Anuluj', // Cancel
};
